import React, { Component } from 'react';

import redirectIcon from '../../../images/redirect-icon.png';
import './NoConditionExist.css';


class NoConditionExist extends Component {
  
  static defaultProps = {
    toggleConditionModal : () => {
      console.error("toggleConditionModal props not deliveried to NoConditionExist");
    }
  }
  
  noConditionExistMessage = "컨디션이 없습니다.";

  handlingCreateConditionBtn = (e) => {
    const { toggleConditionModal } = this.props;

    toggleConditionModal();
  }

  render() {

    const { noConditionExistMessage } = this;
    const { handlingCreateConditionBtn } = this;

    return (
      <div class="no-conditions-exist">
        <span class="no-conditions-text">
          <span class="text">
            {noConditionExistMessage}
          </span>
        </span> 
        <div class="right-options">
          <button class="create-condition-btn" onClick={handlingCreateConditionBtn} >
            생성
            {/* <p class="title"> 생성 </p> */}
          </button>
        </div>
      </div>
    );
  }
}

export default NoConditionExist;